module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./favicon.ico
// module id = 713
// module chunks = 7